















































































import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { SelectWings, ScrollButton } from "wings-ui-components";
import PushApplicationsFilter from '@/components/Push/Applications/PushApplicationsFilter.vue';
import BaseItemsPage from '../BaseItemsPage';
import { PartnerSelectionItem } from '@/store/types';


@Component({components:{PushApplicationsFilter, ScrollButton, SelectWings}})
export default class PushApplications extends BaseItemsPage<PartnerSelectionItem> {
  @Getter("pushApplications") pushApplicationsResponse: any;
  private is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";
  tableFields = [
    'id',
    'name',
    'description',
  ];

  getData(): any {
    return this.pushApplicationsResponse;
  }
}
